import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import { integrationsInfoKeys } from "../../../../api/queryKeys";
import InitialScanBanner from "../../../../components/InitialScanBanner";
import SvgToIcon from "../../../../icons/SvgToIcon";
import PotentialButton from "./IntegrationPotential/PotentialButton";

export default function Guideline({
  name,
  title,
  subTitle = "",
  image,
  content,
  subContent = null,
  iconWidth = 40,
  iconHeight = 40,
  iconBorderRadius = 99,
  xs = 9,
}) {
  const { getIntegrationsInfo } = useAPI();

  const integrationName = window.location.pathname.split("/").pop();

  const integrationsInfoQuery = useQuery({
    queryKey: integrationsInfoKeys.all,
    queryFn: getIntegrationsInfo,
    select: (response) => response.data,
  });

  return (
    <Box>
      <Grid container>
        <Grid item xs={xs}>
          <Stack direction="column" sx={{ mt: 3, ml: 5, mr: 5 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              {image ? (
                <SvgToIcon
                  IconLogo={image}
                  width={String(iconWidth)}
                  height={String(iconHeight)}
                />
              ) : (
                <div />
              )}
              <Box display="flex" gap={6} alignItems="center">
                <Typography variant="h4">{name}</Typography>
                {integrationName && (
                  <PotentialButton
                    integrationName={integrationName}
                    integrationsInfoQuery={integrationsInfoQuery}
                  />
                )}
              </Box>
            </Stack>
            <Box sx={{ mt: 3 }}>
              <Typography variant="h5">{title}</Typography>
              <Typography variant="subtitle1">{subTitle}</Typography>
            </Box>
            <Box sx={{ mt: 3, mb: 5 }}>{content}</Box>
          </Stack>
        </Grid>
        {subContent && (
          <>
            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
            <Grid item xs={3}>
              <Box sx={{ mt: 5, ml: 2, mr: 2 }}>{subContent}</Box>
            </Grid>
          </>
        )}
        <Box sx={{ mt: 3, ml: 5 }}>
          <InitialScanBanner showFullMessage={false} />
        </Box>
      </Grid>
    </Box>
  );
}
